import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { commitStagedFiles } from '@/services/git/api';
import type { CommitStagedFilesInput, PushOperationCreated } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useCommitStagedFiles(): UseMutationResult<PushOperationCreated, Error, CommitStagedFilesInput> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? '');

  return useMutation({
    mutationFn: (input: CommitStagedFilesInput) => commitStagedFiles(orgId, input),
    // Staged files are invalidated after the push operation completes, not on creation.
  });
}
